/**
 * Formats integer minor units as a plain signed decimal string in major units,
 * with no currency symbol, no thousands separator, and exactly two decimal
 * places: the money-column convention for CSV worksheets, and the value an
 * amount or rate input is seeded with (the parse helpers read it back).
 *
 * The bare counterpart to formatCurrency (which renders a display string like
 * "R1,500.00"): same minor-units input, but a machine-parseable decimal out. A
 * signed-zero input renders "0.00", never "-0.00".
 *
 * Example: formatMinorUnitsAsDecimal(150000) => '1500.00'
 *          formatMinorUnitsAsDecimal(-10000) => '-100.00'
 *          formatMinorUnitsAsDecimal(0)      => '0.00'
 */
export function formatMinorUnitsAsDecimal(minorUnits) {
    const value = (minorUnits || 0) / 100;
    return value.toFixed(2);
}
